import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { Box, Stack, Typography } from '@mui/material';
import { NoCameraAccessCnt, WarningBox } from './style';
import NoCameraAccessIcon from 'components/Icons/noCameraAccessIcon';

const NoCameraAccess = () => {
  return (
    <NoCameraAccessCnt>
      <Box className="emptyCnt">
        <NoCameraAccessIcon className="noCameraAccessIcon" />
      </Box>
      <WarningBox>
        <Stack direction="row" alignItems="start" gap="10px">
          <WarningAmberOutlinedIcon />
          <Stack
            direction="column"
            gap="5px"
            alignItems="start"
            textAlign="left"
          >
            <Typography className="title">
              Camera Permission Required
            </Typography>
            <Typography className="description">
              Camera access is required to record a video. Please enable camera
              permissions in your browser settings and try again.
            </Typography>
          </Stack>
        </Stack>
      </WarningBox>
    </NoCameraAccessCnt>
  );
};

export default NoCameraAccess;
